import { MemberTypeCreatePage } from '@/features/member-type/pages/MemberTypeCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/member-type/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["member_type.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: MemberTypeCreatePage,
})
